/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamGoldenRecordsResponseDto
 */
export interface StreamGoldenRecordsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof StreamGoldenRecordsResponseDto
     */
    requestId: string;
    /**
     * 
     * @type {string}
     * @memberof StreamGoldenRecordsResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof StreamGoldenRecordsResponseDto
     */
    clientName: string;
    /**
     * 
     * @type {Date}
     * @memberof StreamGoldenRecordsResponseDto
     */
    from: Date;
    /**
     * 
     * @type {Date}
     * @memberof StreamGoldenRecordsResponseDto
     */
    to: Date;
    /**
     * 
     * @type {number}
     * @memberof StreamGoldenRecordsResponseDto
     */
    batchSize: number;
    /**
     * 
     * @type {boolean}
     * @memberof StreamGoldenRecordsResponseDto
     */
    treated: boolean;
    /**
     * 
     * @type {string}
     * @memberof StreamGoldenRecordsResponseDto
     */
    batchSubject: string;
}

/**
 * Check if a given object implements the StreamGoldenRecordsResponseDto interface.
 */
export function instanceOfStreamGoldenRecordsResponseDto(value: object): value is StreamGoldenRecordsResponseDto {
    if (!('requestId' in value) || value['requestId'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('batchSize' in value) || value['batchSize'] === undefined) return false;
    if (!('treated' in value) || value['treated'] === undefined) return false;
    if (!('batchSubject' in value) || value['batchSubject'] === undefined) return false;
    return true;
}

export function StreamGoldenRecordsResponseDtoFromJSON(json: any): StreamGoldenRecordsResponseDto {
    return StreamGoldenRecordsResponseDtoFromJSONTyped(json, false);
}

export function StreamGoldenRecordsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamGoldenRecordsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'],
        'assetId': json['assetId'],
        'clientName': json['clientName'],
        'from': (new Date(json['from'])),
        'to': (new Date(json['to'])),
        'batchSize': json['batchSize'],
        'treated': json['treated'],
        'batchSubject': json['batchSubject'],
    };
}

export function StreamGoldenRecordsResponseDtoToJSON(json: any): StreamGoldenRecordsResponseDto {
    return StreamGoldenRecordsResponseDtoToJSONTyped(json, false);
}

export function StreamGoldenRecordsResponseDtoToJSONTyped(value?: StreamGoldenRecordsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
        'assetId': value['assetId'],
        'clientName': value['clientName'],
        'from': value['from'].toISOString(),
        'to': value['to'].toISOString(),
        'batchSize': value['batchSize'],
        'treated': value['treated'],
        'batchSubject': value['batchSubject'],
    };
}

